module.exports = __webpack_public_path__ + "media/images/soar/sign_up_cartoon-162c086a8f9502d3c6addedb82da03c1.png";